import { Component, ElementRef, Inject, NgZone, OnInit, ViewChild } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute, Router } from '@angular/router';
import * as moment from 'moment';
import { AppService } from 'src/app/core/services/app.service';
import { Web3Service } from 'src/app/core/services/web3.service';
// import { this.Contracts_Rinkeby } from 'src/environments/environment';
import { ContractService } from 'src/app/core/services/contract.service';
import { environment } from 'src/environments/environment';
import { CommanSubscribeService } from 'src/app/core/services/comman-subscribe.service';
import { API } from 'aws-amplify';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { Chart, registerables } from 'chart.js';
import { UserService } from 'src/app/core/services/user.service';
import { ToastrService } from 'ngx-toastr';
import { ConsumerAcceptTeamsComponent } from '../../landing-pages/consumer/consumer-accept-teams/consumer-accept-teams.component';
import { ConsumerSignInComponent } from '../../landing-pages/consumer/consumer-sign-in/consumer-sign-in.component';
import { StorageService } from 'src/app/core/services/storage.service';
import { WalletConnectDialogComponent } from '../../wallet-connect-dialog/wallet-connect-dialog.component';
import { AppPaymentTVService } from 'src/app/core/services/app-payment-tv.service';
import { Subscription } from 'rxjs';
import { DomSanitizer } from '@angular/platform-browser';
import { Location } from '@angular/common';
import { COUNTRIES_LIST, API as APICONSTANTS } from '../../../../core/constants';
const LAZY_MINT_JSON = require('src/app/Contracts/Rinkeby/LazyMint.json')
const ERC_20_JSON = require('src/app/Contracts/Rinkeby/ERC20.json')
import { ethers } from 'ethers';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { UserAccountDialog } from '../../event-navigation/pages/event-tickets/event-tickets.component';
import { ConvertTokensComponent } from '../../general/convert-tokens/convert-tokens.component';


@Component({
  selector: 'app-nft-product-overview',
  templateUrl: './nft-product-overview.component.html',
  styleUrls: ['./nft-product-overview.component.scss']
})
export class NftProductOverviewComponent implements OnInit {
  clientDetails:any = environment.clientDetails;
  batchMintStaticData: any = ['https://www.learningcontainer.com/wp-content/uploads/2020/02/Kalimba.mp3', 'http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ElephantsDream.mp4']
  event: any = {}
  displayedColumns: string[] = ['Event', 'Offerprice', 'Quantity', 'Expiration', 'From', 'To'];
  displayedColumnsAuction: string[] = ['Offerprice', 'From', 'Date', 'To'];
  displayedColumnsResale: string[] = ['Price', 'NFTType', 'Creator', 'Copies'];
  dataSource: any = new MatTableDataSource();
  dataSourceAuction: any = new MatTableDataSource();
  dataSourceResale: any = new MatTableDataSource();
  days: number;
  hours: number;
  minutes: number;
  seconds: number;
  erc721: any;
  marketplace: any;
  sellerAddress: any;
  tokenId: any;
  accountNumber: string;
  erc721_address: string;
  marketplace_address: string;
  erc721contract: any;
  erc20contract: any;
  network_name: string;
  collectionId: any;
  tokenarray: any;
  tokenURIsList: any;
  nftPrice: any;
  cryptoSymbol: string;
  userInfo: any;
  nftData: any;
  totalSeconds: any;
  saleEndTime: string;
  contractAddress: string;
  saleDetails: any = { saleStatus: -1, saleText: "Auction Ended" }
  chart: any = "hello";
  collectionDetails: any;
  purchase_price2: any;
  bidDate: string;
  timezoneVal: string;
  nftBidPrice: any;
  nftBuyPrice: number = 1;
  cryptoToken: string;
  cryptoAmount: any;
  available_balance: number = 0;
  selectedToken: string = 'GFL'; // Default to GFL
  tokenOptions = [
    { value: 'GFL', display: 'GFL' },
    { value: 'KP', display: 'KP' }
  ];
  crypto_balance: any;
  metamaskinstalled: boolean = false;
  termsandconditions: boolean = false;
  settingsData: any;
  nftFiatPrice: any;
  channelUrl: any;
  currentLocation: any;
  getCurrency: any;
  USD_Rates: any;
  currencyInfoSubscription: any;
  nftList: any = [];
  currentPlayingAudio: HTMLAudioElement;
  showPlayBtn: boolean = true;
  nftAvailableCopies: number = 0;
  nftFormat: string;
  chartLabels: any = [];
  chartData: number[] = [];
  showMore: boolean = false;
  showMore1: boolean = false;
  nftResalePrice: number;
  openResaleSideBar: boolean = false;
  accounchanged: Subscription;
  highestBid: number;
  nftBidInfo: any;
  bidValidator: boolean = false;
  nftHighestBidFiatCurrency: number;
  active: number = 0;
  @ViewChild('paginator', { static: true }) paginator: MatPaginator;
  @ViewChild('auctionPaginator', { static: true }) paginatorAuction: MatPaginator;
  @ViewChild('resalePaginator', { static: true }) paginatorResale: MatPaginator;
  nftFiatPrice1: number;
  Contracts_Rinkeby: any;
  clientDetailsName: string = '';

  constructor(private contractservice: ContractService, private web3service: Web3Service,
    private userService: UserService, private ngxLoader: NgxUiLoaderService,
    private route: ActivatedRoute, private appService: AppService, private router: Router,
    private commanService: CommanSubscribeService, private toastr: ToastrService, private _matDialog: MatDialog, private storageService: StorageService,
    private appPaymentService: AppPaymentTVService, private ngZone: NgZone, private sanitizer: DomSanitizer, private location: Location) {
    Chart.register(...registerables)
  }

  ngOnInit() {
    this.Contracts_Rinkeby = this.web3service.Contracts_Rinkeby;
    this.accounchanged = this.web3service.getchangeaccount().subscribe(data => {

      // data = data.toLowerCase();
      this.accountNumber = data;
      this.getbidInfo();
      this.getNftData();
      // this.accountChanged(data);
    });
    if (localStorage.getItem('WalletId') && localStorage.getItem('WalletId') != '') {
      this.accountNumber = localStorage.getItem('WalletId');
      this.web3service.intermidateConnect()
      this.web3service.setContract();
      this.Contracts_Rinkeby = this.web3service.Contracts_Rinkeby;
    } else {
      this.web3service.connectedAccId.subscribe(walletId => {
        // alert(walletId)
        this.accountNumber = walletId

      }
      )
    }
    // this.web3service.connectedAccId.subscribe(walletId => this.accountNumber = walletId)
    this.settingsData = this.commanService.icWebpageSettingsData;
    this.timezoneVal = this.userService.getTimezone();
    this.dataSource.paginator = this.paginator;
    this.dataSourceAuction.paginator = this.paginatorAuction;
    this.dataSourceResale.paginator = this.paginatorResale;
    this.network_name = environment.clientDetails.network_name
    this.web3service.setNetwork(this.network_name)
    this.cryptoSymbol = environment.clientDetails.crypto_symbol
    this.cryptoToken = environment.clientDetails.crypto_token;
    this.clientDetailsName = environment.clientDetails.name
    this.userInfo = this.commanService.userInfo;
    // this.getNftList();
    // this.web3service.connectedAccId.subscribe(walletId => this.accountNumber = walletId)
    this.getNftData();
    this.getCurrency = this.storageService.getItem('currency');
    let locInfo = this.commanService.locationInfo;
    this.currentLocation = locInfo && Object.keys(locInfo).length > 0 ? locInfo : this.storageService.getItem('current_location');
    if (!this.currentLocation || Object.keys(this.currentLocation).length == 0) {
      this.commanService.getCurrentLocation((val: any, json: any) => {
        if (val == "fail") {
          this.currentLocation = this.currentLocation ? this.currentLocation : {};
          this.getCurrency = this.getCurrency ? this.getCurrency : this.currentLocation["currency"]["code"];
        } else {
          this.currentLocation = json;
        }
      });
    }
    if (this.currentLocation && Object.keys(this.currentLocation).length > 0)
      this.getCurrency = this.getCurrency ? this.getCurrency : this.currentLocation["currency"]["code"];
    this.currencyInfoSubscription = this.commanService.getCurrencyInfo().subscribe(response => {
      if (response) {
        this.getCurrency = this.storageService.getItem('currency');
        this.getCurrencyRates();
      }
    });
    this.getCurrency = this.getCurrency ? this.getCurrency : this.storageService.getItem('currency');
    console.log("bid details", this.nftData, this.saleDetails, this.nftBidInfo);
  }

  createChart() {
    this.chartLabels = this.chartLabels.reverse();
    this.chartData = this.chartData.reverse()
    this.chart = new Chart("MyChart", {
      type: 'line', //this denotes tha type of chart
      data: {
        labels: this.chartLabels,
        datasets: [{
          label: 'Price',
          data: this.chartData,
          fill: false,
          borderColor: 'rgb(75, 192, 192)',
          tension: 0.1
        }],
      },
      options: {
        responsive: true,
        scales: {
          x: {
            ticks: { color: 'white' },
          },
          y: {
            ticks: { color: 'white', stepSize: 30 },
            beginAtZero: true
          }
        },
        plugins: {
          legend: {
            display: false,
          }
        }
      },
    });
  }
  convertTransactionDate() {
    this.dataSource.data.map((data) => {
      data.transaction_date = moment.utc(data.transaction_date).toDate();
      data.transaction_date = moment(data.transaction_date).format('DD/MM/YYYY hh:mm A');
      // data.transaction_date = moment(data.transaction_date,"YYYYMMDD").fromNow();
    })
    this.dataSourceAuction.data.map((data) => {
      data.bid_date = moment.utc(data.bid_date).toDate();
      data.bid_date = moment(data.bid_date).format('DD/MM/YYYY hh:mm A');
      // data.transaction_date = moment(data.transaction_date,"YYYYMMDD").fromNow();
    })
  }
  OnBuy(nftId?) {
    console.log("on buy called with token:", this.selectedToken);
    if (this.termsandconditions || (this.nftData.nftType == 'single' || this.nftData.nftType == 'batch')) {
      this.web3service.checkAndInstantiateWeb3().then(async (isweb3: any) => {
        if (isweb3 === 'connected' && (this.accountNumber != '')) {
          await this.web3service.getchainId().then((chainid) => {
            if (chainid == this.nftData.blockchain) {
              this.web3service.setNetwork(this.network_name)
              this.web3service.setNetwork(this.network_name);
              this.web3service.setContract();
              if (this.accountNumber == this.nftData.bought_by && this.nftData.nftType == 'single') {
                this.toastr.error("NFT already bought");
                return;
              }
              let erc20contract = this.selectedToken === "GFL" ? this.web3service.getContract('ERC20') : this.web3service.getContract('ERC20_Kombat');
              console.log(">>>>");
              erc20contract.methods.balanceOf(this.accountNumber).call().then(resp => {
                console.log("???????????", resp);
                let available_balance = Number(resp) / (10 ** 18)
                let crypto_balance = Math.trunc(available_balance * Math.pow(10, 3)) / Math.pow(10, 3);
                this.available_balance = available_balance
                this.crypto_balance = crypto_balance;
                console.log("available_balance", available_balance);
                console.log("crypto_balance", crypto_balance);
                if (this.nftData.saleType == 'lazymint') {
                  this.onBuyLazymint()
                }
                else {
                  if (this.nftData.nftType == 'batch' || this.nftData.nftType == "multibatch") {
                    this.onBuyBatch();
                  }
                  else {
                    if (this.nftData.nftType == 'single') {
                      // if(this.nftData.saleType == 'batch'){
                      //   this.onBuyBatch();
                      //   return
                      // }
                      console.log("single buy",this.nftData.salePrice, this.available_balance, this.nftData.salePrice <= this.available_balance);
                      if (this.nftData.salePrice <= this.available_balance) {
                        this.web3service.sendnftstep({ payStep: 1, type: 'instant' });
                        this.openGraphData({ payStep: 1, type: 'instant' });
                        this.nftPrice = this.web3service.convertPriceToEther(this.nftData.salePrice)
                        erc20contract.methods.approve(this.Contracts_Rinkeby.MARKET_PLACE_ADDRESS, this.nftPrice).send({ from: this.accountNumber })
                          .then(response => {
                            this.web3service.sendnftstep({ payStep: 2, type: 'instant' });
                            let marketplacecontract = this.web3service.getContract('MarketPlace');
                            let cAddress = this.nftData.tokenId.split('_')[0] != 'lazy' ? this.Contracts_Rinkeby.SINGLE_NFT721_ADDRESS : this.Contracts_Rinkeby.LAZY_MINT_ADDRESS;
                            marketplacecontract.methods.getFixedSale(cAddress, this.tokenId).call().then(response => {
                              marketplacecontract.methods.buyFromFixedSale(cAddress, this.tokenId, this.nftPrice).send({ from: this.accountNumber })
                                .once('receipt', (receipt) => {
                                  this.web3service.sendnftstep({ payStep: 3, type: 'instant' });
                                  // alert("Successfully bought the NFT")
                                  if (receipt.status == true) {
                                    receipt.nft_id = this.nftData.resaleNFTID;
                                    this.saveTransactionInfo(receipt);
                                  }
                                  else {
                                    this.toastr.error("Transaction Failed");
                                  }

                                  this.web3service.sendnftstep({ payStep: 0, type: 'instant' });
                                })
                                .catch(e => {
                                  if (e.message.includes('User denied transaction signature')) {
                                    this.toastr.error('Transaction Rejected.');
                                  }
                                  this.web3service.sendnftstep({ payStep: 0, type: 'instant' });
                                  console.log(e)
                                })
                            }).catch(e => {
                              if (e.message.includes('User denied transaction signature')) {
                                this.toastr.error('Transaction Rejected.');
                              }
                              this.web3service.sendnftstep({ payStep: 0, type: 'instant' });
                              console.log(e)
                            })

                          })
                          .catch(e => {
                            this.web3service.sendnftstep({ payStep: 0, type: 'instant' });
                            if (e.message.includes('User denied transaction signature')) {
                              this.toastr.error('Transaction Rejected.');
                            }
                            if (e.message.includes('The requested account and/or method has not been authorized by the user.')) {
                              this.toastr.error("Your wallet has been blocked");
                            }
                            console.log(e)
                          })
                      }
                      else if (this.nftData.salePrice > this.available_balance) {
                        this.openGraphData({ addfunds: true, amount: this.nftData.salePrice, walletID: this.accountNumber });
                      }
                    }
                    else if (this.nftData.nftType == 'multiple') {
                      // if(this.nftData.saleType == 'batch'){
                      //   this.onBuyBatch();
                      //   return
                      // }
                      let saleprice = this.nftData.reSalePrice && this.nftData.reSalePrice != '' ? this.nftData.reSalePrice : this.nftData.salePrice;
                      let supply = this.nftData.reSaleSupply && this.nftData.reSaleSupply != '' ? this.nftData.reSaleSupply : this.nftData.supply;
                      // this.nftAvailableCopies = this.nftData.availableCopies != null ? this.nftData.availableCopies : this.nftData.number_of_copies_for_sale;
                      let saleId = this.nftData.reSaleSaleID && this.nftData.reSaleSaleID != '' ? this.nftData.reSaleSaleID : this.nftData.saleId;
                      let amount1 = Number(saleprice) * this.nftBuyPrice
                      if ((this.nftAvailableCopies >= this.nftBuyPrice) && this.nftBuyPrice > 0 && (amount1 <= this.available_balance)) {
                        let amount2 = this.web3service.convertPriceToEther(amount1)
                        this.web3service.sendnftstep({ payStep: 1, type: 'instant' });
                        this.openGraphData({ payStep: 1, type: 'instant' });
                        erc20contract.methods.approve(this.Contracts_Rinkeby.MARKET_PLACE_1155_ADDRESS, amount2).send({ from: this.accountNumber })
                          .then(response => {
                            this.web3service.sendnftstep({ payStep: 2, type: 'instant' });
                            let marketplacecontract_1155 = this.web3service.getContract('MarketPlace_1155');
                            marketplacecontract_1155.methods.getFixedSale(this.Contracts_Rinkeby.MULTIPLE_NFT1155_ADDRESS, this.tokenId, Number(saleId))
                              .call().then(Response => {
                                marketplacecontract_1155.methods.buyFromFixedSale(this.Contracts_Rinkeby.MULTIPLE_NFT1155_ADDRESS, this.tokenId, amount2,
                                  Number(saleId), this.nftBuyPrice, "0x00")
                                  .send({ from: this.accountNumber })
                                  .once('receipt', (receipt) => {
                                    this.web3service.sendnftstep({ payStep: 0, type: 'instant' })
                                    // alert("Successfully bought the multiple NFT")
                                    if (receipt.status == true) {
                                      receipt.nft_id = this.nftData.resaleNftID ? this.nftData.resaleNftID : this.nftData.tokenId
                                      this.web3service.sendnftstep({ payStep: 3, type: 'instant' });
                                      this.saveTransactionInfo(receipt, this.nftBuyPrice);
                                    }
                                    else {
                                      this.toastr.error("Transaction Failed");
                                      console.log('s')

                                    }
                                    this.web3service.sendnftstep({ payStep: 0, type: 'instant' });
                                    // this.dataOfBuyNft();
                                  })
                                  .catch(e => {
                                    if (e.message.includes('User denied transaction signature')) {
                                      this.toastr.error('Transaction Rejected.');
                                    }
                                    this.web3service.sendnftstep({ payStep: 0, type: 'instant' });
                                    console.log(e)
                                  })
                              })
                          })
                          .catch(e => {
                            if (e.message.includes('User denied transaction signature')) {
                              this.toastr.error('Transaction Rejected.');
                              this.web3service.sendnftstep({ payStep: 0, type: 'instant' });
                            }
                            console.log(e)
                            this.web3service.sendnftstep({ payStep: 0, type: 'instant' });
                          })
                      }

                      else if (this.nftBuyPrice <= 0) {
                        this.toastr.error("Please enter valid copies")
                      }
                      else if (amount1 > this.available_balance) {
                        this.openGraphData({ addfunds: true, amount: amount1, walletID: this.accountNumber });
                      }
                      else {
                        this.toastr.error('There are only ' + this.nftAvailableCopies + ' available')
                      }

                    }

                  }
                }
              })
                .catch((e) => {
                  if (e.message.includes('The requested account and/or method has not been authorized by the user.')) {
                    this.toastr.error("Your wallet has been blocked");
                  }
                })

            }
            else {
              // let chaindata = this.nftData.blockchain == 'Polygon' ? 'poly' : 'Avalanche';
              let chaindata = this.nftData.blockchain == 'Polygon' ? 'Polygon' : 'Sepolia';
              localStorage.setItem('networkId', chaindata);
              this.web3service.changeNetwork(chaindata).then(data => {
                if (!data || data == null) {
                  this.web3service.setNetwork(this.network_name);
                  this.web3service.setContract();
                  if (this.accountNumber == this.nftData.bought_by && this.nftData.nftType == 'single') {
                    this.toastr.error("NFT already bought");
                    return;
                  }

                  let erc20contract = this.web3service.getContract('ERC20');
                  erc20contract.methods.balanceOf(this.accountNumber).call().then(resp => {
                    let available_balance = Number(resp) / (10 ** 18)
                    let crypto_balance = Math.trunc(available_balance * Math.pow(10, 3)) / Math.pow(10, 3);
                    this.available_balance = available_balance
                    this.crypto_balance = crypto_balance
                    if (this.nftData.saleType == 'lazymint') {

                      this.onBuyLazymint()
                    }
                    else {
                      if (this.nftData.nftType == 'batch' || this.nftData.nftType == "multibatch") {
                        this.onBuyBatch();
                      }
                      else {
                        if (this.nftData.nftType == 'single') {
                          // if(this.nftData.saleType == 'batch'){
                          //   this.onBuyBatch();
                          //   return
                          // }
                          if (this.nftData.salePrice <= this.available_balance) {
                            this.web3service.sendnftstep({ payStep: 1, type: 'instant' });
                            this.openGraphData({ payStep: 1, type: 'instant' });
                            this.nftPrice = this.web3service.convertPriceToEther(this.nftData.salePrice)
                            erc20contract.methods.approve(this.Contracts_Rinkeby.MARKET_PLACE_ADDRESS, this.nftPrice).send({ from: this.accountNumber })
                              .then(response => {
                                this.web3service.sendnftstep({ payStep: 2, type: 'instant' });
                                let marketplacecontract = this.web3service.getContract('MarketPlace');
                                let cAddress = this.nftData.tokenId.split('_')[0] != 'lazy' ? this.Contracts_Rinkeby.SINGLE_NFT721_ADDRESS : this.Contracts_Rinkeby.LAZY_MINT_ADDRESS;
                                marketplacecontract.methods.getFixedSale(cAddress, this.tokenId).call().then(response => {
                                  marketplacecontract.methods.buyFromFixedSale(cAddress, this.tokenId, this.nftPrice).send({ from: this.accountNumber }).once('receipt', (receipt) => {
                                    this.web3service.sendnftstep({ payStep: 3, type: 'instant' });
                                    // alert("Successfully bought the NFT")
                                    if (receipt.status == true) {
                                      receipt.nft_id = this.nftData.resaleNFTID;

                                      this.saveTransactionInfo(receipt);
                                    }
                                    else {
                                      this.toastr.error("Transaction Failed");
                                      console.log('s')

                                    }

                                    this.web3service.sendnftstep({ payStep: 0, type: 'instant' });
                                  })
                                })
                                  .catch(e => {
                                    if (e.message.includes('User denied transaction signature')) {
                                      this.toastr.error('Transaction Rejected.');
                                    }
                                    this.web3service.sendnftstep({ payStep: 0, type: 'instant' });
                                    console.log(e)
                                  })

                              })
                              .catch(e => {
                                if (e.message.includes('User denied transaction signature')) {
                                  this.toastr.error('Transaction Rejected.');
                                }
                                if (e.message.includes('The requested account and/or method has not been authorized by the user.')) {
                                  this.toastr.error("Your wallet has been blocked");
                                }
                                this.web3service.sendnftstep({ payStep: 0, type: 'instant' });
                                this.opendata = false;
                                console.log(e)
                              })
                          }
                          else if (this.nftData.salePrice > this.available_balance) {
                            this.openGraphData({ addfunds: true, amount: this.nftData.salePrice, walletID: this.accountNumber });
                          }
                        }
                        else if (this.nftData.nftType == 'multiple') {
                          // if(this.nftData.saleType == 'batch'){
                          //   this.onBuyBatch();
                          //   return
                          // }
                          let saleprice = this.nftData.reSalePrice && this.nftData.reSalePrice != '' ? this.nftData.reSalePrice : this.nftData.salePrice;
                          let supply = this.nftData.reSaleSupply && this.nftData.reSaleSupply != '' ? this.nftData.reSaleSupply : this.nftData.supply;
                          // this.nftAvailableCopies = this.nftData.availableCopies != null ? this.nftData.availableCopies : this.nftData.number_of_copies_for_sale;
                          let saleId = this.nftData.reSaleSaleID && this.nftData.reSaleSaleID != '' ? this.nftData.reSaleSaleID : this.nftData.saleId;
                          let amount1 = Number(saleprice) * this.nftBuyPrice
                          if ((this.nftAvailableCopies >= this.nftBuyPrice) && this.nftBuyPrice > 0 && (amount1 <= this.available_balance)) {
                            let amount2 = this.web3service.convertPriceToEther(amount1)
                            this.web3service.sendnftstep({ payStep: 1, type: 'instant' });
                            this.openGraphData({ payStep: 1, type: 'instant' });
                            erc20contract.methods.approve(this.Contracts_Rinkeby.MARKET_PLACE_1155_ADDRESS, amount2).send({ from: this.accountNumber })
                              .then(response => {
                                this.web3service.sendnftstep({ payStep: 2, type: 'instant' });
                                let marketplacecontract_1155 = this.web3service.getContract('MarketPlace_1155');
                                marketplacecontract_1155.methods.getFixedSale(this.Contracts_Rinkeby.MULTIPLE_NFT1155_ADDRESS, this.tokenId, Number(saleId))
                                  .call().then(Response => {
                                    marketplacecontract_1155.methods.buyFromFixedSale(this.Contracts_Rinkeby.MULTIPLE_NFT1155_ADDRESS, this.tokenId, amount2,
                                      Number(saleId), this.nftBuyPrice, "0x00")
                                      .send({ from: this.accountNumber })
                                      .once('receipt', (receipt) => {
                                        this.web3service.sendnftstep({ payStep: 0, type: 'instant' })
                                        // alert("Successfully bought the multiple NFT")
                                        if (receipt.status == true) {
                                          receipt.nft_id = this.nftData.resaleNftID ? this.nftData.resaleNftID : this.nftData.tokenId
                                          this.web3service.sendnftstep({ payStep: 3, type: 'instant' });
                                          this.saveTransactionInfo(receipt, this.nftBuyPrice);
                                        }
                                        else {
                                          this.toastr.error("Transaction Failed");
                                          console.log('s')

                                        }
                                        this.web3service.sendnftstep({ payStep: 0, type: 'instant' });
                                        // this.dataOfBuyNft();
                                      })
                                      .catch(e => {
                                        if (e.message.includes('User denied transaction signature')) {
                                          this.toastr.error('Transaction Rejected.');
                                        }
                                        this.opendata = false;
                                        this.web3service.sendnftstep({ payStep: 0, type: 'instant' });
                                        console.log(e)
                                      })
                                  })
                              })
                              .catch(e => {
                                if (e.message.includes('User denied transaction signature')) {
                                  this.toastr.error('Transaction Rejected.');
                                  this.web3service.sendnftstep({ payStep: 0, type: 'instant' });
                                }
                                console.log(e)
                                this.opendata = false;
                                console.log(e)
                                this.web3service.sendnftstep({ payStep: 0, type: 'instant' });
                              })
                          }

                          else if (this.nftBuyPrice <= 0) {
                            this.toastr.error("Please enter valid copies")
                          }
                          else if (amount1 > this.available_balance) {
                            this.openGraphData({ addfunds: true, amount: amount1, walletID: this.accountNumber });
                          }
                          else {
                            this.toastr.error('There are only ' + this.nftAvailableCopies + ' copies available')
                          }

                        }

                      }
                    }
                  })
                    .catch((e) => {
                      if (e.message.includes('The requested account and/or method has not been authorized by the user.')) {
                        this.toastr.error("Your wallet has been blocked");
                      }
                    })
                }
                else {
                  // this.toastr.error("Please switch your network")
                }
              })
            }
          });
        }
        else {
          this.connectWallet();
        }
      })
    }
    else {
      this.toastr.error("Please accept the terms and conditions")
    }

  }

  decimalCount(num) {
    var numStr = String(num);
    // String Contains Decimal
    if (numStr.includes('.')) {
      return numStr.split('.')[1].length;
    }
    // String Does Not Contain Decimal
    return 0;
  }

  checkDecimals(number: any) {
    var decimalNumber = this.decimalCount(number);
    if (decimalNumber > 3) {
      return true;
    } else {
      return false;
    }
  }

  async onBuyLazymint() {
    this.web3service.sendnftstep({ payStep: 1, type: 'instant' });
    this.openGraphData({ payStep: 1, type: 'instant' });
    let token_id = typeof this.nftData.tokenId == 'string' ? String(this.nftData.tokenId).split('_')[1] : this.nftData.tokenId;
    let price = this.nftData.salePrice;
    let token_uri = this.nftData.lazymint_key?.img_hash.split('ipfs/')[1];
    let r = this.nftData.lazymint_key.r;
    let s = this.nftData.lazymint_key.s;
    let v = this.nftData.lazymint_key.v;
    let signature = this.nftData.lazymint_key.signature
    this.nftPrice = this.web3service.convertPriceToEther(price)
    let erc20contract = this.web3service.getContract('ERC20')
    let lazymintcontract = this.web3service.getContract('LAZYMINT');

    try {
      // =====================================================================>Erc20 Approve
      let provider = new ethers.providers.Web3Provider(window.ethereum);
      let signer = provider.getSigner();
      const approveContract = new ethers.Contract(
        this.Contracts_Rinkeby.ERC_20_ADDRESS,
        ERC_20_JSON,
        signer
      );

      const approveTx = await approveContract.approve(this.Contracts_Rinkeby.LAZY_MINT_ADDRESS, this.nftPrice)
      this.web3service.sendnftstep({ payStep: 2, type: 'instant' });
      await approveTx.wait()
      //   // =>>>>>>>>>>Lazy minting call
      const lazyContract = new ethers.Contract(
        this.Contracts_Rinkeby.LAZY_MINT_ADDRESS,
        LAZY_MINT_JSON,
        signer
      );
      let erc20Address = this.nftData.token_type === "GFL" ? this.Contracts_Rinkeby.ERC_20_ADDRESS : this.Contracts_Rinkeby.ERC_20_ADDRESS_Kombat;

      // console.log(this.accountNumber, v, r, s, this.nftPrice, [token_id, this.nftPrice, token_uri, '0x' + signature])
      const lazyTx = await lazyContract.redeem(this.accountNumber, v, r, s, this.nftPrice, [token_id, this.nftPrice, token_uri, '0x' + signature], erc20Address)
      await lazyTx.wait().then(data => {
        data.nft_id = this.nftData.resaleNftID ? this.nftData.resaleNftID : this.nftData.tokenId
        this.web3service.sendnftstep({ payStep: 3, type: 'instant' });
        this.saveTransactionInfo(data, 1)
      })
      // =>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>EVents
      lazyContract.on("LazyMint", async (seller, buyer, salePrice) => {
        let info = {
          seller: seller,
          buyer: buyer,
          salePrice: salePrice.toString(),
        };
      });
    }
    catch (error) {
      this.web3service.sendnftstep({ payStep: 0, type: 'instant' });
      console.log('>>>>>>>>>>>>>>>>>>><<<<<<<<<<<<<<<<<<<<<<<<', error)
    }
  }
  async onBuyBatch() {
    let amount1 = this.nftData.salePrice
    if ((this.nftAvailableCopies >= this.nftBuyPrice) && this.nftBuyPrice > 0 && (amount1 <= this.available_balance)) {
      this.web3service.sendnftstep({ payStep: 1, type: 'instant' });
      this.openGraphData({ payStep: 1, type: 'instant' });
      let erc20contract = this.web3service.getContract('ERC20');
      let copies = this.nftData.nftType == 'batch' ? 1 : this.nftBuyPrice;
      let OverallPrice = this.nftData.reSalePrice && this.nftData.reSalePrice != '' ? Number(this.nftData.reSalePrice) * Number(copies) : Number(this.nftData.salePrice) * Number(copies)
      let batchPrice = this.web3service.convertPriceToEther(OverallPrice);
      let token_id = this.nftData.reSaleSaleID ? Number(this.nftData.reSaleSaleID) : Number(this.nftData.saleId);
      let copies_arr = Array(this.nftData.batch_ids.length).fill(Number(copies));
      let batchmintmintmarketplace = this.web3service.getContract('BATCHMINT_MarketPlace')
      await erc20contract.methods.approve(this.Contracts_Rinkeby.BATCH_MINT_MARKETPLACE_ADDRESS, batchPrice).send({ from: this.accountNumber })
        .then(response => {
          this.web3service.sendnftstep({ payStep: 2, type: 'instant' });
          batchmintmintmarketplace.methods.buyFromFixedSale(this.Contracts_Rinkeby.BATCH_MINT_ADDRESS, token_id, batchPrice, copies, copies_arr, "0x00").send({ from: this.accountNumber })
            .then(resp => {
              if (this.nftData.nftType == 'batch') {
                if (this.nftData.bid_nft_id) {
                  resp.nft_id = this.nftData.bid_nft_id;
                }
              }
              else {
                resp.nft_id = this.nftData.resaleNftID ? this.nftData.resaleNftID : this.nftData.tokenId
              }
              this.web3service.sendnftstep({ payStep: 3, type: 'instant' });
              this.saveTransactionInfo(resp, copies);
            }).catch(error => {
              this.web3service.sendnftstep({ payStep: 0, type: 'instant' });
              this.toastr.error('Transaction Failed');
              console.log('s')

              this.opendata = false;
            })
        }).catch(error => {
          this.web3service.sendnftstep({ payStep: 0, type: 'instant' });
          this.toastr.error('Transaction Failed');
          console.log('s')

          this.opendata = false;
        })
    }
    else if (this.nftBuyPrice <= 0) {
      this.toastr.error("Please enter valid copies")
    }
    else if (amount1 > this.available_balance) {
      this.openGraphData({ addfunds: true, amount: amount1, walletID: this.accountNumber });
    }
    else {
      this.toastr.error('There are only ' + this.nftAvailableCopies + ' copies available')
    }

  }
  goBack() {
    this.location.back()
  }
  displayTime: any;
  startTimer() {

    if (this.displayTime) {
      clearInterval(this.displayTime)
    }
    this.displayTime = setInterval(() => {
      let today = moment().utc().format("YYYY-MM-DD HH:mm:ss").valueOf()
      let currentDateInMillisecs: any = moment(today).valueOf();
      let startTimeInMillisecs = moment(this.nftData.saleStartTime, "YYYY-MM-DD HH:mm:ss").local().valueOf();
      let endTimeInMillisecs = moment(this.saleEndTime, "YYYY-MM-DD HH:mm:ss").local().valueOf()
      if ((currentDateInMillisecs - endTimeInMillisecs > 0)) {
        this.totalSeconds = 0;
        this.saleDetails = { saleStatus: -1, saleText: "Auction Ended" };
      }
      else {
        if (startTimeInMillisecs < currentDateInMillisecs) {
          this.totalSeconds = endTimeInMillisecs - currentDateInMillisecs;
          this.saleDetails = { saleStatus: 1, saleText: "Auction Ends in" };

        }
        else {
          this.totalSeconds = startTimeInMillisecs - currentDateInMillisecs;
          this.saleDetails = { saleStatus: 0, saleText: "Auction Starts in" };
        }
      }
      if (this.totalSeconds > 0) {
        this.days = Math.floor(this.totalSeconds / 86400000);
        this.hours = Math.floor((this.totalSeconds - (this.days * 86400000)) / 3600000);
        this.minutes = Math.floor((this.totalSeconds - ((this.days * 86400000) + this.hours * 3600000)) / 60000);
        this.seconds = Math.floor((this.totalSeconds - ((this.days * 86400000) + (this.hours * 3600000) + (this.minutes * 60000))) / 1000);
        this.totalSeconds = this.totalSeconds - 1000;
      } else {
        // this.totalSeconds = 1654612923000;
        this.days = 0;
        this.hours = 0;
        this.minutes = 0;
        this.seconds = 0;
      }
    }, 1000)
  }
  connectWallet(buy?) {
    console.log("connect wallet called", buy);
    this.web3service.checkAndInstantiateWeb3().then(isweb3 => {
      console.log(isweb3, "isweb3");
      if (isweb3 === 'connected') {
        this.metamaskinstalled = true;
        this.web3service.connectAccount().then(async (response) => {
          console.log("response connect account", response);
          this.accountNumber = response;
          await this.web3service.getchainId().then((chainid) => {
            console.log("cahin id", chainid);
            if (chainid == this.nftData.blockchain) {
              this.web3service.setContract();
              if (response == undefined || response == '') {
                return
              }
              if (response) {
                // this.web3service.setContract();
                console.log("response after set contract", response);
                // this.commanService.getAccountBalance(this.accountNumber);
                this.cryptoAmount = this.commanService.getCryptoBalance().subscribe((result) => {
                  this.available_balance = result.available_balance;
                  this.available_balance > 0 ? this.crypto_balance = result.crypto_balance : this.crypto_balance = 0.00;
                })
              }
              if (buy) {
                setTimeout(() => {
                  this.openrightnav();
                }, 1000);
              }
            }
            else {
              // let chaindata = this.nftData.blockchain == 'Polygon' ? 'poly' : 'Avalanche';
              let chaindata = this.nftData.blockchain == 'Polygon' ? 'Polygon' : 'Sepolia';
              localStorage.setItem('networkId', chaindata);
              this.web3service.changeNetwork(chaindata).then(data => {
                if (!data || data == null) {
                  this.web3service.setContract();
                  if (response == undefined || response == '') {
                    return
                  }
                  if (response) {
                    this.web3service.setContract();
                    this.commanService.getAccountBalance(this.accountNumber);
                    this.cryptoAmount = this.commanService.getCryptoBalance().subscribe((result) => {
                      this.available_balance = result.available_balance;
                      this.available_balance > 0 ? this.crypto_balance = result.crypto_balance : this.crypto_balance = 0.00;
                    })
                  }
                  if (buy) {
                    setTimeout(() => {
                      this.openrightnav();
                    }, 1000);
                  }
                }
                else {
                  this.toastr.error("Please switch your network")
                }
              })
            }
          })
        })
      }
    })
      .catch((e) => {
        this._matDialog.open(WalletConnectDialogComponent, {
          // backdropClass:'blurred',
          // disableClose: true,
          panelClass: "app-consumer-sign-in",
          hasBackdrop: true
        });
      })

  }
  getCopies(callback) {
    let erc1155contract = this.web3service.getContract('ERC1155')
    let marketplacecontract_1155 = this.web3service.getContract('MarketPlace_1155')
    erc1155contract.methods.balanceOf(marketplacecontract_1155._address, this.nftData.tokenId)
      .call().then(resp => {
        this.nftAvailableCopies = resp;
        callback()
      })
  }
  OnMakeBid(data?, nft_id?) {
    if (this.bidValidator) {
      return
    }
    if (this.termsandconditions) {
      this.web3service.checkAndInstantiateWeb3().then((isweb3: any) => {
        if (isweb3 === 'connected' && this.accountNumber != '') {
          let erc20contract = this.web3service.getContract('ERC20');
          erc20contract.methods.balanceOf(this.accountNumber).call().then(resp => {
            let available_balance = Number(resp) / (10 ** 18)
            let crypto_balance = Math.trunc(available_balance * Math.pow(10, 3)) / Math.pow(10, 3);
            this.available_balance = available_balance
            this.crypto_balance = crypto_balance
            if (this.available_balance > this.nftBidPrice) {
              let marketplacecontract = this.web3service.getContract('MarketPlace')
              // this.nftPrice = this.web3service.convertPriceToEther(this.event['salePrice'])
              this.purchase_price2 = this.web3service.convertPriceToEther(this.nftBidPrice)
              this.web3service.sendnftstep({ payStep: 1, type: 'auction' });
              this.openGraphData({ payStep: 1, type: 'auction' });
              if (this.nftData.nftType == 'single') {
                erc20contract.methods.approve(this.Contracts_Rinkeby.MARKET_PLACE_ADDRESS, this.purchase_price2).send({ from: this.accountNumber })
                  .then(response => {
                    this.web3service.sendnftstep({ payStep: 2, type: 'auction' });
                    let marketplacecontract = this.web3service.getContract('MarketPlace')
                    let cAddress = this.nftData.tokenId.split('_')[0] != 'lazy' ? this.Contracts_Rinkeby.SINGLE_NFT721_ADDRESS : this.Contracts_Rinkeby.LAZY_MINT_ADDRESS;
                    marketplacecontract.methods.makeBid(cAddress, this.tokenId, this.purchase_price2)
                      .send({ from: this.accountNumber })
                      .once('receipt', receipt => {
                        if (receipt.status) {
                          this.toastr.success("Bid Successful")
                          this.saveAuctionInfo();
                        }
                        else {
                          this.toastr.error("Bid Unsuccessful")
                        }
                        this.web3service.sendnftstep({ payStep: 3, type: 'auction' });
                      })
                      .catch(e => {
                        if (e.message.includes('User denied transaction signature')) {
                          this.ngxLoader.stop();
                          this.toastr.error('Transaction Rejected.');
                        }
                        console.log(e)
                        this.web3service.sendnftstep({ payStep: 0, type: 'auction' });
                      })
                  })
                  .catch(e => {
                    if (e.message.includes('User denied transaction signature')) {
                      this.toastr.error('Transaction Rejected.');
                    }
                    console.log(e)
                    this.web3service.sendnftstep({ payStep: 0, type: 'auction' });
                  })
              }
              if (this.nftData.nftType == 'multiple' || this.nftData.nftType == 'batch') {
                erc20contract.methods.approve(this.Contracts_Rinkeby.MARKET_PLACE_1155_ADDRESS, this.purchase_price2).send({ from: this.accountNumber })
                  .then(response => {
                    this.web3service.sendnftstep({ payStep: 2, type: 'auction' });
                    let marketplacecontract_1155 = this.web3service.getContract('MarketPlace_1155')
                    marketplacecontract_1155.methods.makeBid(this.Contracts_Rinkeby.MULTIPLE_NFT1155_ADDRESS,
                      this.tokenId, this.purchase_price2)
                      .send({ from: this.accountNumber }).once('receipt', receipt => {
                        this.ngxLoader.stop();
                        if (receipt.status == true) {
                          this.toastr.success("Bid Successful")
                          this.saveAuctionInfo();
                          this.web3service.sendnftstep({ payStep: 3, type: 'auction' });
                        }
                        else
                          this.toastr.error("Bid Unsuccessful")
                        // this.router.navigate(['/nft-profile'])
                        this.web3service.sendnftstep({ payStep: 0, type: 'auction' });
                      })
                      .catch(e => {
                        if (e.message.includes('User denied transaction signature')) {
                          this.ngxLoader.stop();
                          this.toastr.error('Transaction Rejected.');
                        }
                        console.log(e)
                        this.web3service.sendnftstep({ payStep: 0, type: 'auction' });
                      })
                  })
                  .catch(e => {
                    if (e.message.includes('User denied transaction signature')) {
                      this.ngxLoader.stop();
                      this.toastr.error('Transaction Rejected.');
                    }
                    console.log(e)
                    this.web3service.sendnftstep({ payStep: 0, type: 'auction' });
                  })
              }
            }
            else {
              this.openGraphData({ addfunds: true, amount: environment.ONE_USD, walletID: this.accountNumber });
            }
          })
        }
      })
    }
    else {
      this.toastr.error("Please accept terms and conditions")
    }

  }

  OnUpdateBid() {
    if (this.bidValidator) {
      return
    }
    if (this.termsandconditions) {
      this.web3service.checkAndInstantiateWeb3().then((isweb3: any) => {
        if (isweb3 === 'connected' && this.accountNumber != '') {
          let erc20contract = this.web3service.getContract('ERC20');
          erc20contract.methods.balanceOf(this.accountNumber).call().then(resp => {
            let available_balance = Number(resp) / (10 ** 18)
            let crypto_balance = Math.trunc(available_balance * Math.pow(10, 3)) / Math.pow(10, 3);
            this.available_balance = available_balance
            this.crypto_balance = crypto_balance
            if (this.available_balance > this.nftBidPrice) {
              let marketplacecontract = this.web3service.getContract('MarketPlace')
              this.nftPrice = this.web3service.convertPriceToEther(this.nftData.salePrice)
              this.purchase_price2 = this.web3service.convertPriceToEther(this.nftBidPrice)
              this.web3service.sendnftstep({ payStep: 1, type: 'auction' });
              this.openGraphData({ payStep: 1, type: 'auction' });
              if (this.nftData.nftType == 'single') {
                erc20contract.methods.approve(this.Contracts_Rinkeby.MARKET_PLACE_ADDRESS, this.purchase_price2).send({ from: this.accountNumber })
                  .then(response => {
                    this.web3service.sendnftstep({ payStep: 2, type: 'auction' });
                    let marketplacecontract = this.web3service.getContract('MarketPlace')
                    let cAddress = this.nftData.tokenId.split('_')[0] != 'lazy' ? this.Contracts_Rinkeby.SINGLE_NFT721_ADDRESS : this.Contracts_Rinkeby.LAZY_MINT_ADDRESS;
                    marketplacecontract.methods.updateTheBidPrice(cAddress,
                      this.tokenId, this.purchase_price2)
                      .send({ from: this.accountNumber })
                      .once('receipt', receipt => {
                        if (receipt.status == true) {
                          this.web3service.sendnftstep({ payStep: 3, type: 'auction' });
                          this.toastr.success("Bid Successful")
                          this.saveAuctionInfo();
                        }
                        else
                          this.toastr.error("Bid Unsuccessful")
                        this.web3service.sendnftstep({ payStep: 0, type: 'auction' });
                        this.ngxLoader.start();
                        this.getNftData();
                        this.ngxLoader.stop();
                      })
                      .catch(e => {
                        if (e.message.includes('User denied transaction signature')) {
                          this.toastr.error('Transaction Rejected.');
                        }
                        console.log(e)
                        this.web3service.sendnftstep({ payStep: 0, type: 'auction' });
                      })
                  })
                  .catch(e => {
                    if (e.message.includes('User denied transaction signature')) {
                      this.toastr.error('Transaction Rejected.');
                    }
                    console.log(e)
                    this.web3service.sendnftstep({ payStep: 0, type: 'auction' });
                  })
              }
              if (this.nftData.nftType == 'multiple') {
                this.web3service.sendnftstep({ payStep: 1, type: 'auction' });
                this.openGraphData({ payStep: 1, type: 'auction' });
                erc20contract.methods.approve(this.Contracts_Rinkeby.MARKET_PLACE_1155_ADDRESS, this.purchase_price2).send({ from: this.accountNumber })
                  .then(response => {
                    this.web3service.sendnftstep({ payStep: 2, type: 'auction' });
                    let marketplacecontract_1155 = this.web3service.getContract('MarketPlace_1155')
                    marketplacecontract_1155.methods.updateTheBidPrice(this.Contracts_Rinkeby.MULTIPLE_NFT1155_ADDRESS,
                      this.tokenId, this.purchase_price2)
                      .send({ from: this.accountNumber })
                      .once('receipt', receipt => {
                        if (receipt.status == true) {
                          this.web3service.sendnftstep({ payStep: 3, type: 'auction' });
                          this.toastr.success("Bid Successful")
                          this.saveAuctionInfo();
                        }
                        else
                          this.toastr.error("Bid Unsuccessful")
                        this.web3service.sendnftstep({ payStep: 0, type: 'auction' });
                        this.getNftData();
                      })
                      .catch(e => {
                        if (e.message.includes('User denied transaction signature')) {
                          this.toastr.error('Transaction Rejected.');
                        }
                        console.log(e)
                        this.web3service.sendnftstep({ payStep: 0, type: 'auction' });
                      })
                  })
                  .catch(e => {
                    if (e.message.includes('User denied transaction signature')) {
                      this.toastr.error('Transaction Rejected.');
                    }
                    console.log(e)
                    this.web3service.sendnftstep({ payStep: 0, type: 'auction' });
                  })
              }
            }
            else {
              this.openGraphData({ addfunds: true, amount: environment.ONE_USD, walletID: this.accountNumber });
            }
          })
        }
        else {
          this.connectWallet();
        }

      })
    }
    else {
      this.toastr.error("Please accept terms and conditions")
    }
  }
  async getHighestBid(data?) {
    this.web3service.setContract()
    let marketplacecontract = this.web3service.getContract('MarketPlace')
    let marketplacecontract_1155 = this.web3service.getContract('MarketPlace_1155')
    console.log("contracts",this.Contracts_Rinkeby, this.web3service.Contracts_Rinkeby);
    let cAddress = String(this.nftData?.tokenId).split('_')[0] == 'lazy' ? this.Contracts_Rinkeby?.LAZY_MINT_ADDRESS : this.Contracts_Rinkeby?.SINGLE_NFT721_ADDRESS;
    console.log("cAddress",cAddress);
    if (this.nftData?.nftType == 'single') {
      await marketplacecontract.methods.getNftAuctionSaleDetails(cAddress, typeof this.nftData.tokenId == 'string' ? String(this.nftData.tokenId).split('_')[1] : this.nftData.tokenId)
        .call().then(Response => {
          this.highestBid = Response['nftHighestBid'] > 1000000 ? Number(Response['nftHighestBid']) / 10 ** 18 : Number(Response['nftHighestBid']);
          this.highestBid = this.highestBid == 0 ? this.nftData.salePrice : this.highestBid;
          let previous_bid = this.nftBidInfo?.length > 0 ? this.nftBidInfo[0].price : 0
          this.nftBidPrice = this.highestBid - previous_bid + 0.01;
          this.bidValidation()
          this.bidValidator = false;
          this.commanService.getCurrencyRates("USD", result => {
            this.USD_Rates = result;
            this.nftHighestBidFiatCurrency = this.commanService.cryptoFiatConversion(this.highestBid, this.USD_Rates[this.getCurrency])
          });
        })

    }
    if (this.nftData.nftType == 'multiple') {
      marketplacecontract_1155.methods.getNftAuctionSaleDetails(this.Contracts_Rinkeby.MULTIPLE_NFT1155_ADDRESS, Number(this.nftData?.tokenId.split('_')[1]))
        .call().then(Response => {
          this.highestBid = Response['nftHighestBid'] / 10 ** 18
        })
    }

  }
  getFormatOfFiles() {
    let batch = this.batchMintStaticData.map((item) => {
      let fileType = item.split('.').pop();
      let type;
      if (fileType == 'png' || fileType == 'jpg' || fileType == 'jpeg' || fileType == 'avif' || fileType == 'gif' || fileType == 'fvg') {
        type = 'image'
      }
      else if (fileType == 'mp3' || fileType == 'wav' || fileType == 'ogg') {
        type = 'audio'
      }
      else if (fileType == 'mp4' || fileType == 'mkv' || fileType == 'mov' || fileType == 'avi') {
        type = 'video'
      }
      else {
        type = 'image'
      }
      return { file: item, type: type }
    })
    this.batchMintStaticData = batch
  }
  auctionDetails: any = []
  nftCopies: any = []
  getNftData() {
    this.ngxLoader.start()
    let url = "nft"
    let myInit = {
      headers: {
        "Content-Type": "application/json",
        "x-api-key": environment.AWS_Cognito.X_Api_Key,
        "Authorization": `Bearer ${this.userInfo.access_token}`
      },
      response: true,
      body: {
        id: this.route.snapshot.params.id, wallet_id: this.accountNumber ? this.accountNumber : null
      }
    }
    console.log('Fetching NFT data with params:', myInit.body);
    API.post(environment.AWS_Cognito.apiName, url, myInit).then(response => {
      if (response.data.statusCode == 200) {
        this.nftData = response.data.response.Item;
        this.nftData.token_type && (this.selectedToken = this.nftData.token_type==="KP" ? "KO+" : this.selectedToken);
        console.log("nft data", this.nftData);
        console.log('Token Type:', this.nftData.token_type, 'Sale Type:', this.nftData.saleType);
        this.nftData.reSalePrice = "";
        this.nftData.reSaleSupply = "";
        this.nftData.resaleTokenId = "";
        this.nftData.availableCopies = null;
        this.nftData.reSaleSaleID = ""
        if (this.nftData.nftType == 'single' || this.nftData.nftType == 'batch') {
          if (response.data.response.nft_copies && response.data.response.nft_copies.length > 0) {
            this.nftData.saleType = response.data.response.nft_copies[0].saleType;
            this.nftData.saleStartTime = response.data.response.nft_copies[0].saleStartTime;
            this.nftData.saleEndTime = response.data.response.nft_copies[0].saleEndTime;
            this.nftData.salePrice = response.data.response.nft_copies[0].salePrice ? response.data.response.nft_copies[0].salePrice : this.nftData.salePrice;
            this.nftData.resaleNFTID = response.data.response.nft_copies[0].nft_id ? response.data.response.nft_copies[0].nft_id : this.nftData.tokenId;
            this.nftData.bid_nft_id = response.data.response.nft_copies[0].nft_id;
            this.nftData.saleId = response.data.response.nft_copies[0].saleId;
          }
        }

        this.auctionDetails = response.data.response.auction_history;
        // if (this.nftData.tokenId.split('_')[0] == 'lazy') {
        //   this.highestBid = Math.max(this.auctionDetails.map(o => Number(o.price))) > 0 ? Math.max(this.auctionDetails.map(o => Number(o.price))) : 0;
        //   this.getCurrencyRates('lazy');
        // }
        this.collectionDetails = response.data.nftCollectionDetails.Item;
        this.saleEndTime = response.data.response.Item.saleEndTime;
        this.nftBidInfo = response.data.response.bid_info || [];
        this.batchMintStaticData = response.data.response.Item.links[0]
        this.batchMintStaticData = this.batchMintStaticData.batch_images ? response.data.response.Item.links[0].batch_images : []
        this.getCurrencyRates();
        this.dataSource.data = response.data.response?.nft_history || [];
        this.dataSourceAuction.data = response.data.response?.auction_history || [];
        this.tokenId = this.commanService.convertTokenIdFormat(this.nftData.tokenId);
        if (this.nftData.nftType == 'multiple' || this.nftData.nftType == 'multibatch') {
          let copiesData = response.data.response?.nft_copies && response.data.response?.nft_copies.length > 0 ?
            response.data.response?.nft_copies : [];
          copiesData = copiesData.filter(item => item.nft_id == item.token_id);
          this.nftData.number_of_copies_for_sale = copiesData.length > 0 ? copiesData[0].number_of_copies_for_sale : 0;
        }
        this.nftCopies = response.data.response?.nft_copies && response.data.response?.nft_copies.length > 0 ?
          response.data.response?.nft_copies : [];
        this.nftCopies = this.nftCopies.filter(item => item.nft_id != item.token_id);
        if (this.nftCopies && this.nftCopies.length > 0) {
          this.checkTimerForResale()
        }
        this.dataSourceResale.data = response.data.response?.nft_copies && response.data.response?.nft_copies.length > 0 ?
          response.data.response?.nft_copies : [];
        this.dataSourceResale.data = this.dataSourceResale.data?.filter(item => (item.nft_id != item.token_id && item.number_of_copies_for_sale > 0));
        this.dataSource.data.map((data) => {
          this.chartLabels.push(moment.utc(data.transaction_date).format("MM/DD"))
          this.chartData.push(parseInt(data.price))
        })
        this.createChart();
        this.convertTransactionDate();
        this.sanitizeImageUrl();
        this.getbidInfo();
        if (this.accountNumber != '' && this.accountNumber != null) {
          this.getHighestBid();
        }
        this.getFormatOfFiles();

        // this.saveTransactionInfo()
        this.contractAddress = this.nftData.nftType == "single" ? this.Contracts_Rinkeby.SINGLE_NFT721_ADDRESS : this.Contracts_Rinkeby.MULTIPLE_NFT1155_ADDRESS;
        if (this.nftData.saleType != 'instant')
          this.startTimer()
      }
      this.ngxLoader.stop()
    }).catch(error => {
      console.log(error)
      this.ngxLoader.stop()
    });
  }
  getCurrencyRates(data?) {
    this.commanService.getCurrencyRates("USD", result => {
      this.USD_Rates = result;
      this.nftFiatPrice = this.commanService.cryptoFiatConversion(this.nftData.salePrice, this.USD_Rates[this.getCurrency])
      if (data) {
        this.nftHighestBidFiatCurrency = this.commanService.cryptoFiatConversion(this.highestBid, this.USD_Rates[this.getCurrency])
      }
    });
  }
  openRightNavDelay(nftId?, data?) {
    console.log("nftId", nftId, data);
    if (!data) {
      this.nftAvailableCopies = this.nftData.number_of_copies_for_sale;
      this.commanService.getAccountBalance(this.accountNumber);
      this.cryptoAmount = this.commanService.getCryptoBalance().subscribe((result) => {
        this.available_balance = result.available_balance;
        this.available_balance > 0 ? this.crypto_balance = result.crypto_balance : this.crypto_balance = 0.00;
      })
      if ((this.nftData.saleType == 'instant' || this.nftData.saleType == 'lazymint') && (this.nftData.nftType == "single" || this.nftData.nftType == 'batch')) {
        if (this.userInfo && this.userInfo.access_token)
          setTimeout(() => {
            this.OnBuy(nftId);
          }, 500);
        else
          this.requireLogin();
      }
      else {
        if (this.userInfo && this.userInfo.access_token) {
          this.nftAvailableCopies = this.nftData.availableCopies != null ? this.nftData.availableCopies : this.nftData.number_of_copies_for_sale;
          this.opendata = true;

        }
        else {
          this.requireLogin();
        }
      }
    }
    else {
      console.log("openRightNavDelay");
      this.nftAvailableCopies = this.nftData.number_of_copies_for_sale;
      this.commanService.getAccountBalance(this.accountNumber);
      this.cryptoAmount = this.commanService.getCryptoBalance().subscribe((result) => {
        this.available_balance = result.available_balance;
        this.available_balance > 0 ? this.crypto_balance = result.crypto_balance : this.crypto_balance = 0.00;
      })
      if ((this.nftData.saleType == 'instant' || this.nftData.saleType == 'lazymint') && (this.nftData.nftType == "single" || this.nftData.nftType == 'batch')) {
        if (this.userInfo && this.userInfo.access_token)
          setTimeout(() => {
            console.log("before calling on buy");
            this.OnBuy(nftId);
          }, 500);
        else
          this.requireLogin();
      }
      else {
        if (this.userInfo && this.userInfo.access_token) {
          if (data) {
            this.commanService.getCurrencyRates("USD", result => {
              this.USD_Rates = result;
              this.nftFiatPrice1 = this.commanService.cryptoFiatConversion(this.nftData.reSalePrice, this.USD_Rates[this.getCurrency])
            });
            this.nftData.reSalePrice = data.salePrice;
            this.nftData.reSaleSupply = data.supply;
            this.nftData.resaleTokenId = data.token_id;
            this.nftData.resaleNftID = data.nft_id;
            this.nftData.reSaleSaleID = data.saleId
            this.nftAvailableCopies = data ? data.number_of_copies_for_sale : this.nftData.number_of_copies_for_sale;
          }
          setTimeout(() => {
            this.opendata = true;
          }, 300)
        }
        else
          this.requireLogin();
      }
    }
  }

  opendata: boolean = false;
  auctionOpen: boolean = false;
  async openrightnav(nftId?, data?) {
    console.log("called open right nav", this.accountNumber);
    if (this.accountNumber != '' && this.accountNumber != null) {
      await this.web3service.getchainId().then((chainid) => {
        console.log("chain>>>>", chainid)
        if (chainid == this.nftData.blockchain || chainid == this.nftData.chain) {
          console.log(data, "data");
          if (!data) {
            if (this.nftData.saleType == 'auction') {
              this.auctionOpen = true;
              this.getHighestBid();
            }
            if (this.nftData.nftType == "multiple" || this.nftData.saleType == "multibatch") {
              this.nftAvailableCopies = data ? data.number_of_copies_for_sale : this.nftData.number_of_copies_for_sale;
              this.openRightNavDelay(nftId);
            }
            else {
              console.log("else");
              this.openRightNavDelay(nftId);
            }
          }
          else {
            if (data.saleType == 'auction') {
              this.getHighestBid(data);
            }
            if (data.nftType == "multiple" || this.nftData.saleType == "multibatch") {
              this.nftAvailableCopies = data ? data.number_of_copies_for_sale : this.nftData.number_of_copies_for_sale;
              this.openRightNavDelay(nftId, data);
            }
            else {
              this.openRightNavDelay(nftId, data);
            }
          }
        }
        else {
          // let chaindata = this.nftData.blockchain == 'Polygon' ? 'poly' : 'Avalanche';
          let chaindata = this.nftData.blockchain == 'Polygon' ? 'Polygon' : 'Sepolia';
          localStorage.setItem('networkId', chaindata);
          this.web3service.changeNetwork(chaindata).then(chainD => {
            if (!chainD || chainD == null) {
              if (!data) {
                if (this.nftData.saleType == 'auction') {
                  this.auctionOpen = true;
                  this.getHighestBid();
                }
                if (this.nftData.nftType == "multiple" || this.nftData.saleType == "multibatch") {
                  this.nftAvailableCopies = data ? data.number_of_copies_for_sale : this.nftData.number_of_copies_for_sale;
                  this.openRightNavDelay(nftId);
                }
                else {
                  this.openRightNavDelay(nftId);
                }
              }
              else {
                if (data.saleType == 'auction') {
                  this.getHighestBid(data);
                }
                if (data.nftType == "multiple" || this.nftData.saleType == "multibatch") {
                  this.nftAvailableCopies = data ? data.number_of_copies_for_sale : this.nftData.number_of_copies_for_sale;
                  this.openRightNavDelay(nftId, data);
                }
                else {
                  this.openRightNavDelay(nftId, data);
                }
              }
            }
          })
        }
      })
    }
    else {
      this.connectWallet('buy');
    }
  }

  onTokenSelect(token:string){
    this.selectedToken = token;
  }

  closeSideMenu() {
    if (this.nftData.reSalePrice) {
      this.nftData.reSalePrice = "";
    }
    if (this.nftData.reSaleSupply) {
      this.nftData.reSaleSupply = "";
    }
    if (this.nftData.resaleTokenId) {
      this.nftData.resaleTokenId = ""
    }
    if (this.nftData.resaleNftID) {
      this.nftData.resaleNftID = "";
    }
    if (this.nftData.availableCopies) {
      this.nftData.availableCopies = null
    }
    this.opendata = false;
    this.termsandconditions = false;
  }
  termsAndConditions(event) {
    if (event.value == 'true') {
      this.termsandconditions = true;
    }
  }
  requireLogin() {
    this.storageService.setItem('skipRedirection', 'yes');
    const dialogRef = this._matDialog.open(ConsumerSignInComponent, {
      maxWidth: "400px",
      panelClass: "app-consumer-sign-in",
      disableClose: true,
      data: {}
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result == "success") {
        this.userInfo = this.commanService.userInfo;
      }
    });
  }
  onPlayingAudio(event) {
    event.preventDefault();
    if (this.currentPlayingAudio === undefined) {
      this.currentPlayingAudio = event.target;
      this.currentPlayingAudio.play();
    } else {
      if (event.target !== this.currentPlayingAudio) {
        this.currentPlayingAudio.pause();
        this.currentPlayingAudio = event.target;
        this.currentPlayingAudio.play();
      }
    }
  }
  playAudio(playStatus) {
    let vid = <HTMLAudioElement>document.getElementById('audio');
    if (vid.readyState >= 2) {
      if (vid) {
        if (playStatus == 'play') {
          vid.play();
          this.showPlayBtn = false;
        }
        else if (playStatus == 'pause') {
          vid.pause();
          this.showPlayBtn = true;
        }
      }
    }
    else {
      this.toastr.error('Audio is not ready to play')
    }
  }
  openConsumerAcceptTeams(isAgrees) {
    // event.preventDefault();
    if (isAgrees) {
      const dialogRef = this._matDialog.open(ConsumerAcceptTeamsComponent, {
        // maxWidth:"320px",
        panelClass: Object.keys(this.settingsData).length > 0 && this.settingsData.form_bg_color ? "app-consumer-signin" : "app-consumer-accept-teams",
        disableClose: true,
        data: {}
      });
      dialogRef.afterClosed().subscribe(result => {
      });
    }
  }
  saveTransactionInfo(receipt, copies?) {
    console.log("receipt", receipt, this.nftData);
    let url = "nft/payment"
    let payload = {
      nft_asset: this.nftData.links,
      nft_name: this.nftData.name,
      collection_name: this.collectionDetails.name,
      collection_id: this.collectionDetails.id,
      price: copies && copies > 1 ? this.nftData.reSalePrice ? Number(this.nftData.reSalePrice) * copies : Number(this.nftData.salePrice) * copies : this.nftData.salePrice,
      sale_type: this.nftData.saleType,
      user_wallet_id: this.accountNumber,
      creator_wallet_id: this.nftData.wallet_id,
      token_id: this.nftData.tokenId,
      no_of_copies: copies && copies > 1 ? copies : 1,
      tx_hash: receipt.transactionHash,
      nft_id: receipt.nft_id || this.nftData.id,
      chain: this.nftData.chain ? this.nftData.chain : this.nftData.blockchain,
      blockchain: this.nftData.chain ? this.nftData.chain : this.nftData.blockchain,
    }
    this.web3service.sendnftstep({ payStep: 0, type: 'instant' });
    this.appPaymentService.postRequest(url, payload).subscribe(response => {
      if (response.status == 0) {
        this.toastr.success("NFT purchased successfully")
        setTimeout(() => {
          this.router.navigate(['/nft-profile'])
        }, 1000)
      }
      else {
        this.toastr.error('NFT cannot be stored ');

      }
    })
  }
  saveAuctionInfo() {
    let url = "nftAuction";
    let payload = {
      bid_by: this.accountNumber,
      bid_to: this.nftData.wallet_id,
      token_id: this.nftData.tokenId,
      price: this.nftBidPrice,
      collection_id: this.collectionDetails.id,
      collection_name: this.collectionDetails.name,
      nft_id: this.nftData.bid_nft_id,
      chain: this.nftData.chain ? this.nftData.chain : this.nftData.blockchain,
      blockchain: this.nftData.chain ? this.nftData.chain : this.nftData.blockchain,
    }

    let myInit = {
      headers: {
        "Content-Type": "application/json",
        "x-api-key": environment.AWS_Cognito.X_Api_Key,
        "Authorization": `Bearer ${this.userInfo.access_token}`
      },
      response: true,
      body: payload
    }
    API.post(environment.AWS_Cognito.apiName, url, myInit).then(response => {
      this.web3service.sendnftstep({ payStep: 0, type: 'auction' });
      this.closeSideMenu();
      setTimeout(() => {
        this.getNftData();
        this.getbidInfo();
        this.getHighestBid();
      }, 1000)
      // this.getbidInfo();
    }).catch(error => {
      console.log(error)
    });
  }
  getbidInfo() {
    let url = "nftAuction";
    let payload = {
      bid_by: this.accountNumber,
      nft_id: this.nftData.bid_nft_id,
      chain: this.nftData.chain ? this.nftData.chain : this.nftData.blockchain,
      blockchain: this.nftData.chain ? this.nftData.chain : this.nftData.blockchain,
    }

    let myInit = {
      headers: {
        "Content-Type": "application/json",
        "x-api-key": environment.AWS_Cognito.X_Api_Key,
        "Authorization": `Bearer ${this.userInfo.access_token}`
      },
      response: true,
      body: payload
    }
    API.post(environment.AWS_Cognito.apiName, url, myInit).then(response => {
      this.web3service.sendnftstep({ payStep: 0, type: 'auction' });
      if (response.data.message == "Success") {
        let bids = []
        if (response.data.bid_info) {
          response.data.bid_info.price = Number(response.data.bid_info.price)
          bids[0] = response.data.bid_info;
        }
        if (bids.length > 0) {
          let filterdBids: any = []
          // filterdBids = bids.map(bid => {
          //   let moent = moment(this.nftData.saleStartTime).diff(bid.saleStartTime, 'seconds')
          //   bid.bidDateTime = moent;
          //   if (moent > 0) {
          //     return bid
          //   }
          //   return null
          //   console.log(moent, "nft data");
          // })
          // console.log(filterdBids, "filters*******")

        }

        this.nftBidInfo = bids;
      }
    }).catch(error => {
      console.log(error)
    });
  }
  withDrawBid() {
    let url = "nftAuction";

    let payload = {
      "action_type": "withdraw_bid",
      nft_id: this.nftData.tokenId,
      chain: this.nftData.chain ? this.nftData.chain : this.nftData.blockchain,
      blockchain: this.nftData.chain ? this.nftData.chain : this.nftData.blockchain,
    }

    let myInit = {
      headers: {
        "Content-Type": "application/json",
        "x-api-key": environment.AWS_Cognito.X_Api_Key,
        "Authorization": `Bearer ${this.userInfo.access_token}`
      },
      response: true,
      body: payload
    }
    API.post(environment.AWS_Cognito.apiName, url, myInit).then(response => {
      this.web3service.sendnftstep({ payStep: 0, type: 'auction' });
      if (response.data.message == "Success") {
        let bids = []
        bids[0] = response.data.bid_info;
        this.nftBidInfo = bids || [];
      }
    }).catch(error => {
      console.log(error)
    });
  }
  nftBidFiatPrice: number;
  nftBidPreviousPrice: number
  totalBidFiatPrice: number;
  bidValidation() {
    if (this.nftBidPrice < 0) {
      this.nftBidPrice = '';
      return
    }
    let bidInfoPrice = this.nftBidInfo?.length ? this.nftBidInfo[0].price : 0
    this.commanService.getCurrencyRates("USD", result => {
      this.USD_Rates = result;
      this.nftBidFiatPrice = this.commanService.cryptoFiatConversion(this.nftBidPrice, this.USD_Rates[this.getCurrency])
      if (this.nftBidInfo?.length)
        this.nftBidPreviousPrice = this.commanService.cryptoFiatConversion(this.nftBidInfo[0]?.price, this.USD_Rates[this.getCurrency])
      this.totalBidFiatPrice = this.commanService.cryptoFiatConversion(this.nftBidPrice + bidInfoPrice, this.USD_Rates[this.getCurrency])
    });

    if (this.nftBidPrice + bidInfoPrice <= this.highestBid) {
      this.bidValidator = true
    }
    else {
      this.bidValidator = false
    }

  }
  saveResaleInfo() {
    let url = "nftResale";
    let payload = {
      token_id: this.nftData.tokenId,
      wallet_id: this.accountNumber,
      salePrice: this.nftResalePrice,
      chain: this.nftData.chain ? this.nftData.chain : this.nftData.blockchain,
      blockchain: this.nftData.chain ? this.nftData.chain : this.nftData.blockchain,
    }
    let myInit = {
      headers: {
        "Content-Type": "application/json",
        "x-api-key": environment.AWS_Cognito.X_Api_Key,
        "Authorization": `Bearer ${this.userInfo.access_token}`
      },
      response: true,
      body: payload
    }
    API.post(environment.AWS_Cognito.apiName, url, myInit).then(response => {

    }).catch(error => {
      console.log(error)
    });
  }
  pushToMarketPlace(nftaddress) {
    this.ngxLoader.start();
    let erc721contract = this.web3service.getContract('ERC721')
    let marketplacecontract = this.web3service.getContract('MarketPlace')
    if (this.nftResalePrice > 0) {
      erc721contract.methods.setApprovalForAll(this.Contracts_Rinkeby.MARKET_PLACE_ADDRESS, true).send({ from: this.accountNumber })
        .then(response => {
          marketplacecontract.methods.nftFixedSale(nftaddress, this.Contracts_Rinkeby.ERC_20_ADDRESS, this.nftData.tokenId, this.nftResalePrice).send({ from: this.accountNumber })
            .once('receipt', (receipt) => {
              this.ngxLoader.stop()
              this.saveResaleInfo();
            })
            .catch(e => {
              if (e.message.includes('User denied transaction signature')) {
                this.ngxLoader.stop();
                this.toastr.error('Transaction Rejected.');
              }
              console.log(e)
            })
        })
        .catch(e => {
          if (e.message.includes('User denied transaction signature')) {
            this.ngxLoader.stop();
            this.toastr.error('Transaction Rejected.');
          }
          console.log(e)
        })
    }

  }
  pushToMarketPlace_1155() {

    let marketplacecontract_1155 = this.web3service.getContract('MarketPlace_1155')
    marketplacecontract_1155.methods.nftFixedSale(this.Contracts_Rinkeby.MULTIPLE_NFT1155_ADDRESS,
      this.Contracts_Rinkeby.ERC_20_ADDRESS,
      this.nftData.tokenId, Number(2), this.nftData.salePrice, '0x00')
      .send({ from: this.accountNumber })
      .once('receipt', receipt => {
        this.saveResaleInfo();
      })
      .catch(e => {
        if (e.message.includes('User denied transaction signature')) {
          this.ngxLoader.stop();
          this.toastr.error('Transaction Rejected.');
        }
        console.log(e)
        this.ngxLoader.stop();
      })
  }
  resaleNFT() {
    if (this.nftData.nftType == 'single') {
      this.pushToMarketPlace(this.Contracts_Rinkeby.SINGLE_NFT721_ADDRESS);
    }
    if (this.nftData.nftType == 'multiple') {
      this.pushToMarketPlace_1155();
    }
  }

  sanitizeImageUrl() {
    this.nftData.links.banner = this.sanitizer.bypassSecurityTrustStyle(this.nftData.links?.banner)
  }
  toggleResaleSideBar() {
    this.openResaleSideBar = !this.openResaleSideBar;
  }
  openGraphData(data?) {
    this.ngZone.run(() => {
      const dialogRef = this._matDialog.open(nftResponse, {
        disableClose: data.addfunds ? false : true,
        data: {
          ...data,
          selectedToken: this.selectedToken
        }
      });
      dialogRef.afterClosed().subscribe(result => {

      });
    });
  }
  resaleTimerCheck: any;
  checkTimerForResale() {
    this.resaleTimerCheck = setInterval(() => {
      this.nftCopies.forEach(auction => {
        if (auction && auction.saleType == 'auction') {
          let totalSeconds = 0;
          let today = moment().utc().format("YYYY-MM-DD HH:mm:ss").valueOf()
          let currentDateInMillisecs: any = moment().valueOf();
          let startTimeInMillisecs = moment(auction.saleStartTime, "YYYY-MM-DD HH:mm:ss").local().valueOf();
          let endTimeInMillisecs = moment(auction.saleEndTime, "YYYY-MM-DD HH:mm:ss").local().valueOf()
          // console.log(this.auctionDetails, currentDateInMillisecs, startTimeInMillisecs, endTimeInMillisecs)
          // console.log(currentDateInMillisecs, startTimeInMillisecs, endTimeInMillisecs)

          if ((currentDateInMillisecs - endTimeInMillisecs > 0)) {
            // totalSeconds = 0;
            auction.saleDetails = { saleStatus: -1, saleText: "Sale Ended" };
          }
          else {
            if (startTimeInMillisecs < currentDateInMillisecs) {
              // this.totalSeconds = endTimeInMillisecs - currentDateInMillisecs;
              auction.saleDetails = { saleStatus: 1, saleText: "Sale Ends in" };

            }
            else {
              // this.totalSeconds = startTimeInMillisecs - currentDateInMillisecs;
              auction.saleDetails = { saleStatus: 0, saleText: "Sale Starts in" };
            }
          }
        }
      });
      // console.log(this.auctionDetails)
      this.dataSourceAuction.data = this.auctionDetails
    }, 1000)
  }
  ngOnDestroy() {
    clearInterval(this.displayTime);
    if (this.cryptoAmount) {
      this.cryptoAmount.unsubscribe();
    }
    if (this.currencyInfoSubscription) {
      this.currencyInfoSubscription.unsubscribe();
    }
    if (this.resaleTimerCheck) {
      clearInterval(this.resaleTimerCheck)
    }
  }
}

declare var Stripe: any;
declare var fbq: any;
var stripe;
var elements;
@Component({
  selector: 'app-network-popup',
  templateUrl: './nft-response.component.html',
  styleUrls: ['./nft-product-overview.component.scss']
})

export class nftResponse implements OnInit {
  GraphPart = "";
  partnamed = "";
  nftStepSub: any = Subscription;
  cryptoForm: FormGroup;
  savedCardsListSubscr: Subscription;
  savedCardsList: any;
  addNewCard: boolean = false;
  currentTheme: any;
  activeBlock: any;
  card: any;
  cardError: any;
  validStripeForm: boolean = false;
  @ViewChild('cardInfo', { static: false }) cardInfo: ElementRef;
  currencyInfoSubscription: Subscription;
  getCurrency: any;
  selectedBillingAddress: any;
  newCardForCrypto: boolean = false;
  selectedCard: any;
  selectedCardInfoSubscr: Subscription;
  userInfo: any;
  save_card: boolean;
  billingInfoSubscr: Subscription;
  getBillingValue: any;
  isPayment: boolean;
  USD_Rates: any;
  showOverlay: boolean;
  amount: any;
  transactionInfo: { mode: any; card: any; stripe: any; paymentIntent: any; transaction_amount: number; save_card: boolean; processing_fee: any; };
  crypto_pf: any;
  add_amt_to_crypto_wallet: boolean;
  deviceInfo: string = 'web';
  cryptoToken: string;
  crypto_amt_in_user_cur: number;
  Data: any;
  walletID: any;

  constructor(private router: Router,
    public dialogRef: MatDialogRef<nftResponse>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private commonSubscribeService: CommanSubscribeService, private web3service:
      Web3Service, private formBuilder: FormBuilder, private toastr: ToastrService,
    private loader: NgxUiLoaderService, private appPaymentService: AppPaymentTVService
    , private storageService: StorageService, public dialog: MatDialog) {
    this.openGraphDat(this.GraphPart)
  }

  openGraphDat(data?) {
    this.nftStepSub = this.web3service.getnftstep().subscribe(res => {
      this.Data = res;
      if (res.payStep == 0) {
        this.close();
      }
      //console.log(res, "data from the response")
    })


  }
  ngOnInit() {
    this.Data = this.data;
    this.walletID = this.data.walletID;
    this.cryptoForm = this.formBuilder.group({
      crypto_amount: ['', Validators.required]
    });
    this.cryptoToken = environment.clientDetails.crypto_token
    this.currencyInfoSubscription = this.commonSubscribeService.getCurrencyInfo().subscribe(response => {
      if (response) {
        this.getCurrency = this.storageService.getItem('currency');
      }
    });
    this.deviceInfo = this.commonSubscribeService.getMobileOperatingSystem();
    this.currentTheme = this.commonSubscribeService.getThemeColors();
    this.getCurrency = this.storageService.getItem('currency');
    this.currencyInfoSubscription = this.commonSubscribeService.getCurrencyInfo().subscribe(response => {
      if (response) {
        this.getCurrency = this.storageService.getItem('currency');
      }
    });
    this.cryptoForm.patchValue({
      crypto_amount: this.Data.amount
    });
    this.cryptoPF();
    this.selectedCardInfoSubscr = this.commonSubscribeService.getSelectedCardInfo().subscribe(response => {
      this.selectedCard = response;
      if (response) {
        this.addNewCard = false;
        this.newCardForCrypto = false;
        this.selectedBillingAddress = {};
        if (this.selectedCard && this.selectedCard.id) {
          let card = this.selectedCard.billing_address;
          this.selectedBillingAddress.line1 = card.line1;
          this.selectedBillingAddress.line2 = card.line2;
          this.selectedBillingAddress.city = card.city;
          this.selectedBillingAddress.country = card.country;
          this.selectedBillingAddress.state = card.state;
          this.selectedBillingAddress.zip = card.postal_code;
        }
      }
    });
    this.userInfo = this.commonSubscribeService.userInfo;
    this.currencyInfoSubscription = this.commonSubscribeService.getUserInfo().subscribe(response => {
      this.userInfo = response;
      if (this.userInfo && this.userInfo.is_guest) {
        this.save_card = false;
        this.addNewCard = true;
      } else if (this.userInfo.id && !this.userInfo.is_guest) {
        this.save_card = true;
      }
    });
    this.billingInfoSubscr = this.commonSubscribeService.getBillingInfo().subscribe(response => {
      this.getBillingValue = response;
    })
    this.savedCardsListSubscr = this.commonSubscribeService.getSavedCards().subscribe(response => {
      this.savedCardsList = response;
      if (this.savedCardsList.length == 0) {
        this.addNewCard = true;
        this.selectedCard = {}
        if (this.savedCardsList.length == 0) {
          this.save_card = true;
          setTimeout(() => {
            this.initiateCardElement();
          }, 1000);
        }

      }
    });
    let creatorCur = this.getCurrency == "GBP" ? "GBP" : "USD";
    this.loadStripe(this.getCurrency, creatorCur);

  }

  close() {
    this.dialogRef.close();
  }
  loadStripe(currency, creator_currency) {
    let userLocale = 'en';
    const locale = ['ar', 'bg', 'cs', 'da', 'de', 'el', 'en', 'en-GB', 'es', 'es-419', 'et', 'fi', 'fr', 'fr-CA', 'he', 'hu', 'id', 'it', 'ja', 'lt', 'lv', 'ms', 'mt', 'nb', 'nl', 'pl', 'pt-BR', 'pt', 'ro', 'ru', 'sk', 'sl', 'sv', 'tr', 'th', 'zh', 'zh-HK', 'zh-TW'];
    let lang = this.commonSubscribeService.getLanguage();
    if (lang && locale.indexOf(lang) != -1) {
      userLocale = lang;
    }
    if ((currency != 'GBP' && creator_currency == 'USD') || currency == 'USD') {
      stripe = Stripe(environment.STRIPE_US_KEY, { locale: userLocale });
    } else {
      stripe = Stripe(environment.STRIPE_UK_KEY, { locale: userLocale });
    }
    if (this.userInfo.is_guest || !this.userInfo.id) {
      setTimeout(() => {
        this.initiateCardElement();
      }, 2000);
    }
  }
  initiateCardElement() {
    let zip = this.selectedBillingAddress && this.selectedBillingAddress.zip ? this.selectedBillingAddress.zip : this.getBillingValue && this.getBillingValue.zip ? this.getBillingValue.zip : '';
    // if (!elements) {
    elements = stripe.elements()
    // }
    if (this.card) {
      this.card.destroy();
    }
    // if (!this.card) {
    // Giving a base style here, but most of the style is in scss file

    const cardStyle = {
      style: {
        base: {
          color: environment.themeColors.pentanary_bg_font_color1,
          fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
          fontSmoothing: 'antialiased',
          fontSize: '14px',
          '::placeholder': {
            color: environment.themeColors.pentanary_bg_font_color2,
          },
        },
        invalid: {
          color: this.currentTheme.reqMarker,
          iconColor: this.currentTheme.reqMarker,
        },
        hidePostalCode: !this.activeBlock ? true : false,
        value: !this.activeBlock ? { postalCode: zip } : {}
      }
    };

    this.card = elements.create('card', cardStyle);
    this.card.mount(this.cardInfo.nativeElement);
    // this.card.addEventListener('change', this.cardHandler);
    this.card.addEventListener('change', (event) => {
      //console.log(event);
      if (event.error) {
        this.cardError = event.error.message;
      } else {
        this.cardError = null;
      }
      // if (event.value && event.value.postalCode && event.complete) {
      //   this.getTaxPercentage(event.value.postalCode);
      //   this.stripeZip = event.value.postalCode;
      // }
      if (event.complete) {
        this.validStripeForm = true;
      } else {
        this.validStripeForm = false;
      }
    });
    // document.querySelector('input.InputElement')['type'] = "password";
    // }
    this.card.update({ value: { postalCode: zip } });
  }
  get cryptoInfo() {
    return this.cryptoForm.getRawValue();
  }
  async addFundsToCrypto() {
    if (this.cryptoForm.invalid) {
      this.toastr.error('Please enter amount');
      this.commonSubscribeService.scrollToError();
      this.commonSubscribeService.markFormGroupTouched(this.cryptoForm);
      return;
    }
    this.commonSubscribeService.getCurrencyRates("USD", result => {
      this.USD_Rates = result;

      let name;
      name = this.userInfo.user_display_name || this.userInfo.display_name;
      let code;
      if (this.selectedBillingAddress && this.selectedBillingAddress.line1) {
        let cc = this.selectedBillingAddress.country_code ? this.selectedBillingAddress.country_code : this.selectedBillingAddress.country;
        let country = COUNTRIES_LIST.filter(country => (country.alpha3code == cc || country.alpha2code == cc));
        code = country[0].alpha2code;
      }
      let billingAddress;
      billingAddress = {
        'line1': this.getBillingValue && this.getBillingValue.address1 ? this.getBillingValue.address1 : this.selectedBillingAddress && this.selectedBillingAddress.line1 ? this.selectedBillingAddress.line1 : "",
        'line2': this.getBillingValue && this.getBillingValue.address2 ? this.getBillingValue.address2 : this.selectedBillingAddress && this.selectedBillingAddress.line2 ? this.selectedBillingAddress.line2 : "",
        'city': this.getBillingValue && this.getBillingValue.city ? this.getBillingValue.city : this.selectedBillingAddress && this.selectedBillingAddress.city ? this.selectedBillingAddress.city : "",
        'state': this.getBillingValue && this.getBillingValue.state ? this.getBillingValue.state : this.selectedBillingAddress && this.selectedBillingAddress.state ? this.selectedBillingAddress.state : "",
        'country': this.getBillingValue && this.getBillingValue.country.alpha2code ? this.getBillingValue.country.alpha2code : code ? code : "",
        'postal_code': this.getBillingValue && this.getBillingValue.zip ? this.getBillingValue.zip : this.selectedBillingAddress && this.selectedBillingAddress.zip ? this.selectedBillingAddress.zip : ""
      }
      let cardInfo = {
        'card': this.card,
        'billing_details': {
          'name': name || this.userInfo.user_first_name + ' ' + this.userInfo.user_last_name,
          'address': this.card ? { 'postal_code': this.card.address_zip } : Object.keys(billingAddress).length > 0 ? billingAddress : ''
        }
      }
      if (((this.validStripeForm) || (this.selectedCard && this.selectedCard.id))) {
        this.isPayment = true;
        let data = {
          "currency": this.getCurrency,
          "creator_currency": this.getCurrency == "GBP" ? "GBP" : "USD",
          "amount": Number((this.cryptoInfo.crypto_amount / environment.ONE_USD) * this.USD_Rates[this.getCurrency]) + this.crypto_pf
        }
        if (!this.router.url.includes('/stream'))
          this.loader.start();
        let url = APICONSTANTS.GET_SECRET + '?NOLOADER';
        this.appPaymentService.postRequest(url, data).subscribe(result => {
          if (result['status'] == 0) {
            stripe.confirmCardPayment(result['client_secret'], {
              payment_method: Object.keys(this.selectedCard).length > 0 ? this.selectedCard.id : cardInfo,
              setup_future_usage: Object.keys(this.selectedCard).length > 0 ? undefined : 'off_session'
            }).then((result) => {
              if (!this.router.url.includes('/stream'))
                this.loader.stop();
              if (result.error) {
                this.showOverlay = false;
                this.commonSubscribeService.sendPaymentStatus(false);
                // Show error to your customer (e.g., insufficient funds)
                console.log("result.error", result.error);
                this.toastr.error(result.error.message);
              } else {
                // The payment has been processed!
                if (result.paymentIntent.status === 'succeeded') {
                  try { fbq('track', 'StripePaymentSuccess'); } catch (e) { }
                  let addWallet = {
                    "id": result['paymentIntent']['id'],
                    "amount": 0,
                    "currency": this.getCurrency,
                    "creator_currency": this.getCurrency == "GBP" ? "GBP" : "USD",
                    "payment_method": this.save_card && this.addNewCard && !this.userInfo.is_guest ? result.paymentIntent.payment_method : undefined,
                    "organization_id": this.data?.organization_id || undefined,
                  }
                  let url = APICONSTANTS.ADD_WALLET;
                  this.appPaymentService.postRequest(url, addWallet).subscribe(res => {
                    if (res['message'] == 'Success') {
                      this.buyAreveaToken(result['paymentIntent']);
                    } else {
                      try { fbq('track', 'StripePaymentFailed'); } catch (e) { }
                      this.showOverlay = false;
                      this.commonSubscribeService.updateAvailBalSubject.next(true);
                      this.commonSubscribeService.sendPaymentStatus(false);
                      console.log("res.message", res.message);
                      this.toastr.error(res['message']);
                    }
                  });
                }
              }
            });
          } else {
            this.isPayment = false;
            this.showOverlay = false;
            console.log("result.message", result.message);
            this.toastr.error(result["message"]);
            if (!this.router.url.includes('/stream'))
              this.loader.stop();
          }
        }, error => {
          console.log("error", error);
          this.toastr.error(error);
        });
      } else if (!this.cardError) {
        this.cardError = "Please fill all the fields";
      } else if (!this.addNewCard) {
        this.toastr.error("Please select card")
      }
    });
  }

  convertTokens() {
    const dialogRef = this.dialog.open(ConvertTokensComponent, {
      width: '437px',
      data: {
        selectedToken: this.data.selectedToken,
        targetToken: this.data.selectedToken === 'GFL' ? 'KO+' : 'GFL',
        tokensCount: this.cryptoForm.get('crypto_amount').value,
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result && result.success) {
        console.log("result", result);
        this.dialogRef.close();
        this.toastr.success("Tokens converted successfully");
      }
    });
  }
  buyAreveaToken(paymentIntent) {
    this.amount = this.cryptoInfo.crypto_amount
    if (this.walletID) {
      this.web3service.checkAndInstantiateWeb3().then((isweb3: any) => {
        if (isweb3 === 'connected') {
          this.loader.start();
          let amount = this.web3service.convertPriceToEther(this.amount)
          let erc20contract = this.web3service.getContract('ERC20');
          let marketplacecontract = this.web3service.getContract('MarketPlace');
          marketplacecontract.methods.buyToken(erc20contract._address, this.walletID, amount)
            .send({ from: this.walletID })
            .once('receipt', (receipt) => {
              this.loader.stop();
              if (receipt.status == true) {
                this.commonSubscribeService.getAccountBalance(this.walletID);
                this.transactionInfo = {
                  "mode": 'crypto',
                  "card": this.card ? this.card : undefined,
                  "stripe": stripe,
                  "paymentIntent": paymentIntent,
                  "transaction_amount": Number(this.cryptoInfo.crypto_amount.toFixed(2)),
                  "save_card": this.save_card && this.addNewCard && !this.userInfo.is_guest ? true : undefined,
                  "processing_fee": this.crypto_pf
                }
                // this.commonSubscribeService.updateAvailBalSubject.next(true);
                // this.commonSubscribeService.sendTransactionInfo(this.transactionInfo);
                this.toastr.success("Funds added Successfully.");
                this.commonSubscribeService.getAccountBalance(this.walletID);
                this.isPayment = true;
                this.dialogRef.close()
              }
              else {
                this.toastr.error("Failed to Add Funds.");
                
              }

            })
            .catch((e) => {
              console.log("error", e)
              if (e.message.includes('User denied transaction')) {
                this.loader.stop();
                this.toastr.error('Transaction Rejected.');
              }
            })
        }
      })
    }
  }
  saveCard(event) {
    if (event.checked) {
      this.save_card = true;
      if (!this.userInfo.id || (this.userInfo && this.userInfo.is_guest)) {
        this.userInfo.deviceInfo = this.deviceInfo
        const dialogRef = this.dialog.open(UserAccountDialog, {
          panelClass: 'app-signout-confirmation',
          disableClose: true,
          data: this.userInfo
        });
        dialogRef.afterClosed().subscribe(result => {
          if (result == 'no') {
            this.save_card = false;
          }
        });
      }
    } else {
      this.save_card = false;
    }
  }
  onCryptoAmtChange(value) {
    let reqAmt = environment.ONE_USD;
    if (value && Number(value) < Number(reqAmt)) {
      this.cryptoForm.patchValue({
        crypto_amount: reqAmt
      });
      this.toastr.error('Minimum required amount is ' + Number(reqAmt).toFixed(2) + this.cryptoToken);
    }
    this.cryptoPF();
  }
  cryptoPF() {
    this.commonSubscribeService.getCurrencyRates("USD", result => {
      this.USD_Rates = result;
      this.crypto_pf = 0;
      this.crypto_amt_in_user_cur = this.commonSubscribeService.cryptoFiatConversion(this.cryptoInfo.crypto_amount, this.USD_Rates[this.getCurrency]);
      this.crypto_pf = (this.crypto_amt_in_user_cur * (environment.processing_fee / 100)) + environment.fee_percentage;
      this.crypto_pf = Number(this.crypto_pf.toFixed(2));
    });
  }
  addCardForCrypto() {
    this.cardError = "";
    this.add_amt_to_crypto_wallet = true;
    this.selectedCard = {};
    this.validStripeForm = false;
    this.commonSubscribeService.selectedCardSubject.next(false);
    // if(this.savedCardsList.length == 0){
    this.newCardForCrypto = true;
    this.addNewCard = true;
    this.save_card = true;
    setTimeout(() => {
      this.initiateCardElement();
    }, 1000);
    // }
  }
  ngOnDestroy() {
    if (this.nftStepSub)
      this.nftStepSub.unsubscribe();

    if (this.selectedCardInfoSubscr) {
      this.selectedCardInfoSubscr.unsubscribe()
    }
    if (this.currencyInfoSubscription) {
      this.currencyInfoSubscription.unsubscribe();
    }
    if (this.billingInfoSubscr) {
      this.billingInfoSubscr.unsubscribe();
    }
    if (this.savedCardsListSubscr) {
      this.savedCardsListSubscr.unsubscribe();
    }
  }


}